import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/examples/model-selector/model-selector.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
